
import axios from "axios";
// const API_BASE_URL = "http://localhost:5000/";
 const API_BASE_URL = "https://apiv2.iklimdigitals.com/";
export const API_ENDPOINTS = {
  GET_TOTAL_ORDERS: `${API_BASE_URL}api/order/getnumberOfOrders`,
  GET_TOTAL_PACKAGES: `${API_BASE_URL}api/packages/getnumberOfPackages`,
  GET_STATUS_COUNTS: `${API_BASE_URL}api/order/statusCounts`,
  GET_TOTAL_REVENUE: `${API_BASE_URL}api/order/totalCompletedAmount`,
  GET_ALL_ORDERS: `${API_BASE_URL}api/order/getAllOrders`, 
  UPDATE_ORDERS:`${API_BASE_URL}api/order/update`,
  CREATE_ORDERS: `${API_BASE_URL}api/order/create`,
  // DELETE_ORDERS: `${API_BASE_URL}api/order/delete`,
  Login: `${API_BASE_URL}admin/login`,
  Logout: `${API_BASE_URL}admin/logout`,
  ADD_ADMIN: `${API_BASE_URL}admin/addAdmin`,
   GET_ADMINS: `${API_BASE_URL}admin/getAllAdmins`,
   DELETE_ADMIN: `${API_BASE_URL}admin/deleteAdmin/`,
  //TOGGLE_ADMIN: `${API_BASE_URL}admin/toggleStatus`,
  GET_ALL_PACKAGES: `${API_BASE_URL}api/packages`,
  UPDATE_PACKAGES: `${API_BASE_URL}api/packages/update`,
  CREATE_PACKAGES: `${API_BASE_URL}api/packages/create`,
  DELETE_PACKAGES: `${API_BASE_URL}api/packages/delete`,
  GET_ALL_SERVICES: `${API_BASE_URL}api/services`,
  CREATE_SERVICES: `${API_BASE_URL}api/services/create`,
  SEND_CONTACTUS_EMAIL: `${API_BASE_URL}api/contact/send`,
  SEND_EMAIL_RESET_PASSWORD: `${API_BASE_URL}api/contact/password-reset`,
  RESET_PASSWORD: `${API_BASE_URL}admin/request-reset`,
  VERIFY_PAYMENT: `${API_BASE_URL}api/order/verify-payment`,
  ACCEPT_RECEIPT: `${API_BASE_URL}api/order/upload-receipt`,

  // ✅ Sub-services endpoints
  GET_ALL_SUBSERVICES: `${API_BASE_URL}api/subservices`,
  CREATE_SUBSERVICE: `${API_BASE_URL}api/subservices`,
  UPDATE_SUBSERVICE: (id) => `${API_BASE_URL}api/subservices/${id}`,
  DELETE_SUBSERVICE: (id) => `${API_BASE_URL}api/subservices/${id}`,
  
  

  
};
export const BACK_END_API="https://apiv2.iklimdigitals.com/"





const api = axios.create({
  baseURL: API_BASE_URL, // your backend base URL
});

// Request interceptor: attach token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;